import { useTranslation } from 'react-i18next';
import { Button, ConfirmButton } from '@/components/ui';
import type { RegistryApp } from '@/api/console';
import type { AppApprovalVM } from './useAppApproval';

/**
 * EAA-1709: "Kiểm tra kết nối" → "Duyệt" for an app that is not yet enabled.
 * "Duyệt" renders only while `approval.canApprove` — see `useAppApproval` for the
 * rule. Nothing renders for an enabled app: there is nothing to approve.
 */
export function AppApprovalActions({
    app,
    approval,
}: {
    app: RegistryApp;
    approval: AppApprovalVM;
}) {
    const { t } = useTranslation();
    if (app.enabled) return null;

    return (
        <>
            {approval.canRunCheck && (
                <Button
                    onClick={approval.runCheck}
                    disabled={approval.checking || approval.approving}
                >
                    {approval.checking
                        ? t('console.appDetail.connection.check.pending')
                        : t('console.appDetail.connection.check.button')}
                </Button>
            )}
            {approval.canApprove && (
                <ConfirmButton
                    type="primary"
                    label={
                        approval.approving
                            ? t('console.appDetail.approval.approving')
                            : t('console.appDetail.approval.approveButton')
                    }
                    disabled={approval.approving || approval.checking}
                    confirmTitle={t('console.appDetail.approval.confirmTitle')}
                    confirmDescription={t('console.appDetail.approval.confirmBody', {
                        name: app.name,
                        code: app.code,
                    })}
                    onConfirm={approval.approve}
                />
            )}
        </>
    );
}

export default AppApprovalActions;
